import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';
import classNames from 'classnames';
import { REVIEWS_ROOT_ID } from 'src/listing/constants';
import IconDS22 from 'src/common/components/IconDS22';
import Rating from '../../../common/components/Rating';
import styles from './BookingReview.module.scss';
import getClassNames from '../../../common/utils/getClassNames';

export type BookingReviewProps = {
  condensed?: boolean;
  averageRating: number;
  totalReviews: number;
  disabled?: boolean;
};

const BookingReview: FC<BookingReviewProps> = ({
  condensed = false,
  averageRating,
  totalReviews,
  disabled,
}) => {
  const [t] = useTranslation('listing-page');

  if (!disabled && !totalReviews) {
    return null;
  }

  return (
    <a
      href={`#${REVIEWS_ROOT_ID}`}
      className={getClassNames(styles, 'root', classNames({ condensed }, { disabled }))}
    >
      {condensed ? (
        <>
          <IconDS22
            id="star-filled"
            size="m"
            className={getClassNames(styles, 'icon', classNames({ disabled }))}
          />
          <span className={styles.rating}>{`${averageRating.toFixed(1)}`}</span>
        </>
      ) : (
        <Rating
          rating={averageRating}
          size="medium"
        />
      )}
      <span className={getClassNames(styles, 'label', classNames({ condensed }))}>
        {condensed
          ? `(${t('booking-review--review-count', { count: totalReviews })})`
          : t('booking-review--review-count', { count: totalReviews })}
      </span>
    </a>
  );
};

export default BookingReview;
